import { render, staticRenderFns } from "./perfect-dialog.vue?vue&type=template&id=9156d468&scoped=true"
import script from "./perfect-dialog.vue?vue&type=script&lang=js"
export * from "./perfect-dialog.vue?vue&type=script&lang=js"
import style0 from "./perfect-dialog.vue?vue&type=style&index=0&id=9156d468&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9156d468",
  null
  
)

export default component.exports